import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import VimeoPlayer from '@vimeo/player';

import { getSortedVideoThumbnails } from '../../../../../../../util/video';
import PlayButtonIcon from '../../../../../../../components/icons/PlayButtonIcon';
import Button from '../../../../../../../components/global/Button';

const propTypes = {
  greetingVideo: PropTypes.shape({
    id: PropTypes.string,
  }),
  className: PropTypes.string,
};

const GreetingVideo = ({ greetingVideo, className }) => {
  const [videoPlaying, setVideoPlaying] = useState(false);
  const videoElementRef = useRef(null);
  const vimeoPlayerRef = useRef(null);

  const setupVimeoPlayer = () => {
    vimeoPlayerRef.current = new VimeoPlayer(videoElementRef.current);
    vimeoPlayerRef.current.on('ended', () => {
      setVideoPlaying(false);
    });
    vimeoPlayerRef.current.on('play', () => {
      setVideoPlaying(true);
    });
    vimeoPlayerRef.current.on('pause', () => {
      setVideoPlaying(false);
    });
  };

  useEffect(() => {
    if (videoElementRef?.current) {
      // Create a vimeoPlayerRef:
      setupVimeoPlayer();
    }
  }, [videoElementRef?.current]);

  const videoClasses = classNames({
    'specialty-album-greeting-video-iframe': true,
    'specialty-album-greeting-video-iframe-active': videoPlaying,
  });

  const overlayClasses = classNames({
    'specialty-album-greeting-video-overlay': true,
    'specialty-album-greeting-video-overlay-active': !videoPlaying,
  });

  const thumbnail = getSortedVideoThumbnails(greetingVideo.thumbnails)[
    Math.floor(greetingVideo.thumbnails.length / 2)
  ]?.url;

  const containerClasses = classNames({
    'specialty-album-greeting-video': true,
    [className]: !!className,
  });

  return (
    <div className={containerClasses}>
      <img src={thumbnail} alt="Greeting Thumb" />
      <iframe
        className={videoClasses}
        title={greetingVideo.name}
        src={`${greetingVideo.embed_url}&inline=1&badge=0&controls=0`}
        allow="autoplay"
        ref={videoElementRef}
      />
      <Button
        btnStyle="reset"
        onClick={() => {
          if (videoPlaying) {
            vimeoPlayerRef.current.pause();
          } else {
            vimeoPlayerRef.current.play();
          }
        }}
        className={overlayClasses}
      >
        <PlayButtonIcon size={120} color="#fff" />
      </Button>
    </div>
  );
};

GreetingVideo.propTypes = propTypes;

export default GreetingVideo;
